/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import type { LocaleOption } from 'echarts/types/src/core/locale';

/**
 * Language: English.
 */

export const langJA: LocaleOption = {
  time: {
    month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    monthAbbr: [
      '1月',
      '2月',
      '3月',
      '4月',
      '5月',
      '6月',
      '7月',
      '8月',
      '9月',
      '10月',
      '11月',
      '12月',
    ],
    dayOfWeek: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
    dayOfWeekAbbr: ['日', '月', '火', '水', '木', '金', '土'],
  },
  legend: {
    selector: {
      all: 'すべて',
      inverse: '反転',
    },
  },
  toolbox: {
    brush: {
      title: {
        rect: '矩形選択',
        polygon: 'なげなわ選択',
        lineX: '横方向に選択',
        lineY: '縦方向に選択',
        keep: '選択を維持',
        clear: '選択をクリア',
      },
    },
    dataView: {
      title: 'データビュー',
      lang: ['データビュー', '閉じる', '更新'],
    },
    dataZoom: {
      title: {
        zoom: 'ズーム',
        back: 'リセット',
      },
    },
    magicType: {
      title: {
        line: '折れ線グラフに切替',
        bar: '棒グラフに切替',
        stack: '積み上げ',
        tiled: 'タイル',
      },
    },
    restore: {
      title: '復元',
    },
    saveAsImage: {
      title: '画像として保存',
      lang: ['右クリックで画像を保存'],
    },
  },
  series: {
    typeNames: {
      pie: '円グラフ',
      bar: '棒グラフ',
      line: '折れ線グラフ',
      scatter: '散布図',
      effectScatter: 'リップル散布図',
      radar: 'レーダーチャート',
      tree: 'ツリー',
      treemap: 'ツリーマップ',
      boxplot: '箱ひげ図',
      candlestick: 'ローソク足',
      k: 'K線チャート',
      heatmap: 'ヒートマップ',
      map: '地図',
      parallel: 'パラレル座標',
      lines: '線グラフ',
      graph: '関係グラフ',
      sankey: 'サンキーダイアグラム',
      funnel: 'ファネルチャート',
      gauge: 'ゲージ',
      pictorialBar: 'ピクトリアル',
      themeRiver: 'テーマリバー',
      sunburst: 'サンバースト',
      custom: 'カスタムチャート',
      chart: 'チャート',
    },
  },
  aria: {
    general: {
      withTitle: 'これは「{title}」に関するチャートです',
      withoutTitle: 'これはチャートです',
    },
    series: {
      single: {
        prefix: '',
        withName: ' チャートタイプは{seriesType}で、{seriesName}を表しています',
        withoutName: ' チャートタイプは{seriesType}です',
      },
      multiple: {
        prefix: '。{seriesCount}個のチャートシリーズで構成されています',
        withName: ' {seriesId}番目のシリーズは{seriesName}を表す{seriesType}です',
        withoutName: ' {seriesId}番目のシリーズは{seriesType}です',
        separator: {
          middle: '',
          end: '',
        },
      },
    },
    data: {
      allData: 'データは次の通りです：',
      partialData: '最初の{displayCnt}項目：',
      withName: '{name}のデータは{value}です',
      withoutName: '{value}',
      separator: {
        middle: '、',
        end: '。',
      },
    },
  },
};
